export default __webpack_public_path__ + "static/media/close.a54858f6.svg";